(function () {
  var MOBILE_OFFSET =
    'calc(1.75rem + env(safe-area-inset-bottom, 0px))'

  var state = {
    customizeOpen: false,
    cartOpen: false,
  }

  var tidioReady = false

  function shouldHide() {
    return state.customizeOpen || state.cartOpen
  }

  function applyTidioVisibility() {
    if (!tidioReady || !window.tidioChatApi) return
    if (shouldHide()) {
      window.tidioChatApi.hide()
    } else {
      window.tidioChatApi.show()
    }
  }

  function registerTidioStyles() {
    if (!window.tidioChatApi || typeof window.tidioChatApi.adjustStyles !== 'function') return

    window.tidioChatApi.adjustStyles(
      '@media only screen and (max-width: 1024px) { #tidio { bottom: ' +
        MOBILE_OFFSET +
        ' !important; } }'
    )
  }

  function render() {
    applyTidioVisibility()
  }

  function onTidioChatApiReady() {
    tidioReady = true
    registerTidioStyles()
    render()
  }

  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', onTidioChatApiReady)
  } else {
    document.addEventListener('tidioChat-ready', onTidioChatApiReady)
  }

  window.KsTidio = {
    sync: function (_stickyVisible, customizeOpen) {
      state.customizeOpen = !!customizeOpen
      render()
    },
    setCartOpen: function (open) {
      state.cartOpen = !!open
      render()
    },
  }
})()
